import { ImportSystemObjectType } from './import-system-object-type';

export class ImportSystemObject {
    ContentLanguageId = 1;
    ImportSystemObjectType = ImportSystemObjectType.User;
}
